import React, { useState, useEffect } from 'react';
import '../CSS/donnees.css';
import { fetchDataFromFirebaseCycle } from '../FireBase/firebaseService'; // Import du service Firebase

function Donnees() {
  const [data, setData] = useState([]);
  const [position, setPosition] = useState({ x: '5%', y: '70%' }); // Position initiale
  const [isDragging, setIsDragging] = useState(false);
  const collectionName = localStorage.getItem('collectionName') || '/data';

  // Gestion des données Firebase
  useEffect(() => {
    const unsubscribe = fetchDataFromFirebaseCycle(
      collectionName,
      (fetchedData) => setData(fetchedData), // Callback en cas de succès
      (error) => console.error("Error fetching data: ", error) // Callback en cas d'erreur
    );

    return () => unsubscribe(); // Arrêter l'écoute lors du démontage du composant
  }, [collectionName]);

  // Gestion des déplacements
  const handleMouseDown = () => {
    setIsDragging(true);
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({
        x: e.clientX - 300, // Ajustez pour centrer l'objet
        y: e.clientY - 100,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  return (
    <div
      className="donnees-container"
      style={{
        position: 'absolute',
        left: position.x,
        top: position.y,
        cursor: isDragging ? 'grabbing' : 'grab',
      }}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      <div
        className="donnees-box"
        onMouseDown={handleMouseDown}
      >
        <ul className="donnees-list">
          {data.map((item) => (
            <li key={item.id}>
              <strong>ID:</strong> {item.id}, <strong>Ah:</strong> {item.Ah}, <strong>V:</strong> {item.V}, 
              <strong>A:</strong> {item.A}, <strong>S:</strong> {item.S}, <strong>D:</strong> {item.D}, 
              <strong>Deg:</strong> {item.Deg}, <strong>RPM:</strong> {item.RPM}, <strong>HW:</strong> {item.HW}, 
              <strong>Nm:</strong> {item.Nm}, <strong>ThI:</strong> {item.ThI}, <strong>ThO:</strong> {item.ThO}, 
              <strong>AuxA:</strong> {item.AuxA}, <strong>AuxD:</strong> {item.AuxD}, <strong>Flgs:</strong> {item.Flgs}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Donnees;
